module.exports = __webpack_public_path__ + "images/psp/CarStorage/motorcycle-storage.jpg";